export default {
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
    p: '0 30px 30px 30px'
  },
  headerContainer: (withNavigation: boolean) => ({
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    p: withNavigation ? '0 24px 40px 0' : '0 0 40px 0'
  }),
  header: {
    width: '100%',
    textAlign: 'center'
  },
  asideContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    flex: '1 0 0',
    alignSelf: 'stretch'
  },
  attributesContainer: {
    width: '100%'
  },
  singleAttribute: {
    p: '14px 0 11px 0',
    '.button-children-wrapper': {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    }
  },
  attributeHeadingWrapper: {
    display: 'flex',
    height: '20px',
    alignItems: 'center',
    gap: '16px'
  },
  attributeHeading: {
    display: 'flex',
    paddingTop: '2px',
    alignItems: 'baseline',
    gap: '4px'
  },
  valuesContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '20px',
    alignSelf: 'stretch'
  },
  singleValue: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '8px'
  },
  buttonsContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '16px',
    alignSelf: 'stretch'
  },
  buttonsCount: {
    display: 'block',
    width: '100%',
    textAlign: 'center'
  }
};